import { render } from "./StatisticsCollectionsView.vue?vue&type=template&id=f38ec6e0&scoped=true"
import script from "./StatisticsCollectionsView.vue?vue&type=script&lang=js"
export * from "./StatisticsCollectionsView.vue?vue&type=script&lang=js"

import "./StatisticsCollectionsView.vue?vue&type=style&index=0&id=f38ec6e0&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f38ec6e0"]])

export default __exports__